import React from 'react';

export default function Quotation() {
  return (
    <div className="relative bg-[#f3f8f3]">

      {/* Banner Section */}
  
    <div className='md:h-[80vh] h-[60vh] relative'>
          <h2 className='bg-transparent pt-72 z-30 absolute text-white md:pl-48 md:text-8xl text-5xl'>
            Quotation
          </h2>
          <div className='md:h-[80vh] h-[60vh] bg-black opacity-50 w-full absolute z-20'></div>
          <img
            src='https://images.pexels.com/photos/6863518/pexels-photo-6863518.jpeg'
            alt='Contact Us Banner'
            className='h-full w-full object-cover'
          />
        </div>

      {/* src="https://images.pexels.com/photos/6863518/pexels-photo-6863518.jpeg" */}

      {/* Quick Quotation Form Section */}
      <div className="flex justify-center items-center py-12 px-4 sm:px-16 md:px-36">
        <div className="bg-white p-8 rounded-xl shadow-lg w-full sm:w-[80%] md:w-[60%] lg:w-[50%]">

          <p className="text-green-500 text-2xl font-semibold text-center">Quick Quotation</p>
          
          <h3 className="text-3xl font-bold text-center my-6">Get Your Quotation</h3>

          <form className="space-y-6">
            {/* Name */}
            <div className="flex flex-col">
              <label htmlFor="name" className="text-lg font-medium">Your Name*</label>
              <input
                type="text"
                id="name"
                placeholder="Enter your name"
                className="border-b bg-transparent focus:border-green-500 outline-none p-2"
                required
              />
            </div>

            {/* Email */}
            <div className="flex flex-col">
              <label htmlFor="email" className="text-lg font-medium">Your Email*</label>
              <input
                type="email"
                id="email"
                placeholder="Enter your email"
                className="border-b bg-transparent focus:border-green-500 outline-none p-2"
                required
              />
            </div>

            {/* Phone Number */}
            <div className="flex flex-col">
              <label htmlFor="phone" className="text-lg font-medium">Phone Number*</label>
              <input
                type="tel"
                id="phone"
                placeholder="Enter your phone number"
                className="border-b bg-transparent focus:border-green-500 outline-none p-2"
                required
              />
            </div>

            {/* Company Name */}
            <div className="flex flex-col">
              <label htmlFor="company" className="text-lg font-medium">Company Name</label>
              <input
                type="text"
                id="company"
                placeholder="Enter your company name"
                className="border-b bg-transparent focus:border-green-500 outline-none p-2"
              />
            </div>

            {/* Message */}
            <div className="flex flex-col">
              <label htmlFor="message" className="text-lg font-medium">Message*</label>
              <textarea
                id="message"
                placeholder="Enter your message"
                className="border-b bg-transparent focus:border-green-500 outline-none p-2"
                required
              ></textarea>
            </div>

            {/* Submit Button */}
            <div className="flex justify-center">
              <button
                type="submit"
                className="bg-green-500 text-white py-3 px-8 rounded-lg text-lg hover:bg-green-600 transition duration-300"
              >
                Get Quotation
              </button>
            </div>
          </form>
        </div>
      </div>

      {/* Footer Section */}
      <div className="h-[120px] w-full mt-24 flex justify-evenly flex-col md:flex-row bg-white px-4">
        <div className="flex justify-around flex-1 flex-col md:flex-row md:gap-6">
          <h2 className="text-3xl sm:text-4xl uppercase font-bold">South Global EXIM</h2>
          <div className="text-right">
            <p className="text-xl font-[300]">Contact Us 24/7</p>
            <p className="text-2xl text-green-500">+91 98900 73427</p>
          </div>
        </div>
        <div className="bg-green-500 flex justify-center items-center px-6 sm:px-12 text-white text-lg sm:text-3xl font-[300]">
          <h3>1360 Shukrawar Peth, Bharat Bhavan, Pune</h3>
        </div>
      </div>
      
    </div>
  );
}
